import React from "react";
import { icons } from "@img/icons";
import FilePreview from "./FilePreview";

/**
 * File input + attachment hints + preview strip.
 * Props:
 * - files: File[]
 * - onFileUpload: (e) => void
 * - onRemoveFile: (fileName: string) => void
 */
const AttachmentsUploader = ({ files, onFileUpload, onRemoveFile }) => (
  <>
    <div className="form-field">
      <div className="d-flex gap-3 justify-content-between">
        <div>
          <label htmlFor="uploadProblemFiles" className="custom-file-upload">
            <img src={icons.Upload} alt="" /> Choose Files
          </label>
          <span>{files.length === 0 ? " No file chosen" : ""}</span>
          <input
            accept="image/jpeg, image/png, video/mp4, video/webm, video/quicktime"
            type="file"
            id="uploadProblemFiles"
            multiple
            onChange={onFileUpload}
          />
        </div>
        <div className="mb-2">
          <strong>Attachments:</strong>
          <ul className="mb-0">
            <li>Troubleshooting videos or photos</li>
            <li>Screenshot of system error</li>
            <li>Photos of the full unit and issue</li>
          </ul>
        </div>
      </div>
    </div>

    <div className="d-flex flex-row w-100 overflow-auto">
      {files.map((file, i) => (
        <FilePreview key={i} file={file} onRemove={onRemoveFile} />
      ))}
    </div>
  </>
);

export default AttachmentsUploader;
